import { FORM_PARTS } from './formParts';
import type { FormStyleConfig } from './types';

const BASE_STYLE = {
  container: {
    width: '100%',
    position: 'relative',
  },
  requiredIndicator: {
    color: 'alert.error',
    fontFamily: 'default',
    fontWeight: 'heavy',
    fontSize: 'sm',
    lineHeight: 'sm',
    marginStart: 0.25,
  },
  helperText: {
    color: 'feature.placeholder',
    fontFamily: 'default',
    fontWeight: 'default',
    fontSize: 'md',
    lineHeight: 'md',
    mt: 0.5,
  },
} as const;

export const FORM_STYLE_CONFIG: FormStyleConfig = {
  parts: FORM_PARTS,
  baseStyle: BASE_STYLE,
};
